import React, { useEffect } from 'react';
import useBillingStore from '../../../services/useBillingStore';
import FullScreenLoader from '../../FullScreenLoader/FullScreenLoader';

const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amount);
};

const PlanCard = ({ plan, isCurrent, onSelect }) => {
  return (
    <div className={`plan-card ${plan.recommended ? 'recommended' : ''} ${isCurrent ? 'current' : ''}`}>
      <div className="plan-card-header">
        {plan.recommended && (
          <span className="badge badge-primary">Recomendado</span>
        )}
        {isCurrent && (
          <span className="badge badge-success">Plano Atual</span>
        )}
      </div>

      <h3 className="plan-card-name">{plan.name}</h3>
      {plan.tagline && (
        <p className="plan-card-tagline">{plan.tagline}</p>
      )}

      <div className="plan-card-price">
        <span className="price-amount">{formatCurrency(plan.price)}</span>
        <span className="price-period">/ {plan.billing_cycle}</span>
      </div>

      <ul className="plan-features">
        {plan.features && plan.features.map((feature, index) => (
          <li key={index}>
            <span className="feature-icon">✓</span>
            {feature}
          </li>
        ))}
      </ul>

      {!isCurrent && (
        <button
          className={plan.price > 0 ? 'btn-primary' : 'btn-secondary'}
          onClick={() => onSelect(plan)}
          style={{ width: '100%', marginTop: 'auto' }}
        >
          {plan.price > 0 ? 'Fazer Upgrade' : 'Downgrade'}
        </button>
      )}
    </div>
  );
};

const PlanCards = ({ currentPlanId, onSelectPlan }) => {
  const { plans, loading, error, fetchPlans } = useBillingStore();

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  if (loading) {
    < FullScreenLoader message="Carregando Planos..." />
  }

  if (error) {
    return <div className="co-error">Erro ao carregar planos: {typeof error === 'string' ? error : 'Erro desconhecido'}</div>;
  }

  if (!plans || plans.length === 0) {
    return <div className="co-hint">Nenhum plano disponível.</div>;
  }

  return (
    <div className="plans-grid">
      {plans.map((plan) => (
        <PlanCard
          key={plan.id}
          plan={plan}
          isCurrent={plan.id === currentPlanId}
          onSelect={onSelectPlan}
        />
      ))}
    </div>
  );
};

export default PlanCards;
